import { useSelector } from "react-redux"

import ItemSimple from "../Shared/ItemSimple";
import CardGrey from "../../../common/CardGrey";
import { atpProvidersOptions, workerCompsATPPolicyStatusOptionsPayerTypes } from "../../../../lib/systemData";
import DefaultUpdater from "../../../common/DefaultUpdater";
import GroupContainer from "../GroupNew/GroupContainer";
import Tag from "../../../fragments/Tag";
import InsuranceAddress from "../Shared/InsuranceAddress";
import DownloadDocumentLink from "../../../common/DownloadDocumentLink";
import WorkersCompDepartments from "./WorkersCompDepartments";
import EmployerInformation from "./EmployerInformation";
import CopyIconButton from "../../../fragments/CopyIconButton"
import { formatDateLocal } from "../../../../lib/script"
import { getAtpProviderNameFromProviderId } from "../../../../lib/labels"
import {
    COPY_SECTION_SEPARATOR,
    copyLineAlways,
    copyLineCheckboxAlways,
    getInsuranceLocationContact,
    getLastNoteForType,
    joinCopyLines,
} from "../../../../lib/insuranceCopyNotes"

import classes from '../Shared/Item.module.css'
import PayerTypeStatusGlobalModal from "../../../common/modal/PayerTypeStatusGlobalModal";

export default function WorkersCompItemV2({data, apiCase}) {
    const activeCase = useSelector((state) => state.case.activeCase)
    const wcLoc = getInsuranceLocationContact(data, "worker_comp", activeCase)
    const wcLastNote = getLastNoteForType(activeCase?.notes, 8)

    const wcAdjuster = data.adjuster
    const wcAdjusterName = [wcAdjuster?.first_name, wcAdjuster?.last_name].filter(Boolean).join(" ").trim() || null
    const atpDate = data.atp_date ? formatDateLocal(data.atp_date) : null

    const workCompCopyNotesText = joinCopyLines([
        copyLineAlways("WorkComp Liab Co", data.insurance_carrier?.name),
        copyLineCheckboxAlways("ATP Status", data.atp),
        copyLineAlways("ATP Provider", getAtpProviderNameFromProviderId(data.provider_id)),
        copyLineAlways("ATP Date", atpDate),
        copyLineAlways("Approved Treatment Areas", data.approved_treatment_areas),
        COPY_SECTION_SEPARATOR,
        copyLineAlways("Board Claim No", data.board_claim_number),
        copyLineAlways("Claim No", data.claim_number),
        COPY_SECTION_SEPARATOR,
        copyLineAlways("Adjuster", wcAdjusterName),
        copyLineAlways("Adjuster Phone", wcAdjuster?.contact_information?.phone),
        copyLineAlways("Adjuster Fax", wcAdjuster?.contact_information?.fax),
        copyLineAlways("Address", wcLoc.address1),
        copyLineAlways("Adjuster Email", wcAdjuster?.contact_information?.email),
        copyLineAlways("City", wcLoc.city),
        copyLineAlways("State", wcLoc.state),
        copyLineAlways("Zip", wcLoc.zip),
        COPY_SECTION_SEPARATOR,
        copyLineAlways("Employer", data.employer_name),
        copyLineAlways("Employer State", data.employer_state),
        copyLineAlways("Benefits Manager", data.employer_benefits_manager),
        copyLineAlways("Employer Phone", data.employer_phone),
        copyLineAlways("Employer Email", data.employer_email),
        COPY_SECTION_SEPARATOR,
        copyLineAlways("Notes", wcLastNote),
    ])

    return <ItemSimple data={data} mainItem={null} type={apiCase} folder={'worker_comp'}>
        {data.insurance_carrier && <div className={`${classes.item_header} ${classes.row}`}>
            <div>
                <div className={classes.name}>
                    <CopyIconButton textToCopy={workCompCopyNotesText} title="Copy WorkComp notes" />
                    <Tag type={'note'}>{data.insurance_carrier.code}</Tag>
                    <h2>{data.insurance_carrier.name}</h2>                    
                </div>
                {data.insurance_carrier.contact_information && <div className={classes.location}>
                    <i className='ti ti-building-skyscraper'></i>
                    <InsuranceAddress data={data} folder={'worker_comp'}/>
                </div>}
            </div>
            <div className={classes.header_controls}> 
                {data.atp ? (
                    <PayerTypeStatusGlobalModal date={data.policy_status_date} user={data.policy_status_by}>
                        <DefaultUpdater type={'select'} options={workerCompsATPPolicyStatusOptionsPayerTypes()} value={data.policy_status} label={'Policy Status'} identifier={{type: apiCase, field: 'policy_status', folder: 'worker_comp'}} extraOptions={{rtlDrawer: true, fixedDrawer: true}}/>
                    </PayerTypeStatusGlobalModal>
                ) : ''}
            </div>
        </div>}

        {!data.insurance_carrier && <div className={classes.row}>
            <div style={{flex: 1}}>
                <CardGrey>
                    <EmployerInformation data={data} apiCase={apiCase}/>
                </CardGrey>
            </div >
        </div>}
        
        <div className={classes.row}>                        
            <div style={{flex: 1}}>
                <CardGrey >
                    <div className="flex-container" style={{flex: 2}}>
                        <DefaultUpdater type={'input'} value={data.board_claim_number} label={'Board Claim #'} identifier={{type: apiCase, field: 'board_claim_number', folder: 'worker_comp'}} />
                        
                        <DefaultUpdater type={'checkbox'} value={data.attorney} label={'Attorney'} identifier={{type: apiCase, field: 'attorney', folder: 'worker_comp'}} extraOptions={{direction: 'reverse'}}/>
                    </div>
                </CardGrey>
            </div >
            
        </div>   

        {data.insurance_carrier_id && <div className={classes.row}>                        
            <div style={{flex: 1}}>
                <CardGrey >
                    <div className="flex-container ">
                        <DefaultUpdater type={'input'} value={data.claim_number} label={'Claim #'} identifier={{type: apiCase, field: 'claim_number', folder: 'worker_comp'}} extraOptions={{type: 'text', redBorderFlag: !data.claim_number}}/>
                    
                        <DefaultUpdater type={'checkbox'} value={data.atp} label={'ATP'} identifier={{type: apiCase, field: 'atp', folder: 'worker_comp'}} extraOptions={{direction: 'reverse'}} />                            
                     
                        {data.atp ? <>
                            <DefaultUpdater type={'date'} value={data.atp_date} label={'ATP Date'} identifier={{type: apiCase, field: 'atp_date', folder: 'worker_comp'}}/>

                            <DefaultUpdater type={'select'} value={data.provider_id} options={atpProvidersOptions()} label={'Provider Name'} identifier={{type: apiCase, field: 'provider_id', type_id: data.id, folder: 'worker_comp'}} extraOptions={{hasRemove: true, fixedDrawer: true}}/>

                            <DefaultUpdater type={'input'} value={data.approved_treatment_areas} options={atpProvidersOptions()} label={'Approved Treatment Areas'} identifier={{type: apiCase, field: 'approved_treatment_areas', type_id: data.id, folder: 'worker_comp'}} extraOptions={{hasRemove:true}}/>
                            <DefaultUpdater type={'checkbox'} value={data.atp_no_longer_available} label={'Not longer available'} identifier={{type: apiCase, field: 'atp_no_longer_available', folder: 'worker_comp'}} extraOptions={{direction: 'reverse'}} />
                        </> : <>
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </>}
                    </div>
                </CardGrey>
            </div >            
        </div> }       

        {data.insurance_carrier_id && <div className={classes.row}>
            <div className={classes.row_item_full}>
                <CardGrey>
                    
                    <div className={classes.group_container}>
                        <GroupContainer data={data} smsMail={'Insurance Carrier'} label={'location'} folder={'worker_comp'} apiCase={apiCase} fieldsData={{fields: ['location_id', 'location'], fieldId: 'location_id', fieldobj: 'location', group: 'locations', inputLabel: 'Location'}}/>
                    </div>
                    
                    <div className={classes.group_container}>
                        <GroupContainer data={data} smsMail={'Adjuster'} label={'adjuster'} folder={'worker_comp'} apiCase={apiCase} fieldsData={{fields: ['adjuster_id', 'adjuster'], fieldId: 'adjuster_id', fieldobj: 'adjuster', group: 'adjusters', inputLabel: 'Adjuster'}}/>
                    </div>
                    
                    <div className={classes.group_container}>
                        <GroupContainer data={data} smsMail={'Nurse'} label={'nurse'} folder={'worker_comp'} apiCase={apiCase} fieldsData={{fields: ['nurse_id', 'nurse'], fieldId: 'nurse_id', fieldobj: 'nurse', group: 'nurses', inputLabel: 'Nurse Name'}}/>
                    </div>
                </CardGrey>
            </div>
        </div>}

        <div className={classes.row}>
            <CardGrey >
            <div className="flex-container">
                <div >
                    <DefaultUpdater type={'checkbox'} value={data['200a_recieved']} label={'WC 200a Received'} identifier={{type: apiCase, field: '200a_recieved', folder: 'worker_comp'}} extraOptions={{direction: 'reverse', isDisabled: true}} /> 
                </div>
                <div >
                    <DefaultUpdater type={'checkbox'} value={data['200b_recieved']} label={'WC 200b Received'} identifier={{type: apiCase, field: '200b_recieved', folder: 'worker_comp'}} extraOptions={{direction: 'reverse', isDisabled: true}} /> 
                </div>
                <div >
                    <DefaultUpdater type={'checkbox'} value={data['203_recieved']} label={'WC 203 Received'} identifier={{type: apiCase, field: '203_recieved', folder: 'worker_comp'}} extraOptions={{direction: 'reverse', isDisabled: true}} /> 
                </div>
                <div >
                    <DefaultUpdater type={'checkbox'} value={data['207_received']} label={'WC 207 Received'} identifier={{type: apiCase, field: '207_received', folder: 'worker_comp'}} extraOptions={{direction: 'reverse', isDisabled: true}} /> 
                </div>
                {data.wc_205 && <div >
                    <DownloadDocumentLink pdfSlug={'wc_205'} itemId={data.id} apiCase={apiCase} url={data.wc_205}>
                    WC 205 Document
                    </DownloadDocumentLink>
                </div>}

                {data.wc_206 && <div >
                    <DownloadDocumentLink pdfSlug={'wc_206'} itemId={data.id} apiCase={apiCase} url={data.wc_206}>
                        WC 206 Lien Document
                    </DownloadDocumentLink>
                </div>}
            </div>
                
            </CardGrey>            
        </div>   

        {data.insurance_carrier_id && <div className={`${classes.row} `}>
            <div className={`${classes.row_item_full}`}>
                <WorkersCompDepartments data={data}/>   
            </div>
        </div>}

        {data.insurance_carrier && <div className={classes.row}>
            <div style={{flex: 1}}>
                <CardGrey>
                    <EmployerInformation data={data} apiCase={apiCase}/>
                </CardGrey>
            </div >
        </div>} 
    </ItemSimple>
}